import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Stop the browser restoring an old scroll position on reload / back-forward,
// so every page always opens at the top.
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const ScrollToTop = () => {
  const { pathname } = useLocation();

  // Layout effect runs before paint, so the new page never flashes at the old position.
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
